import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { PAYMENT_METHODS_VALUES } from 'utils/constants'

const validationSchema = Yup.object().shape({
  paymentDate: Yup.mixed().nullable().required('This field is required'),
  completionDate: Yup.mixed().nullable().required('This field is required'),
  paymentMethod: Yup.string().nullable(),
  startingCheckNumber: Yup.string()
    .nullable()
    .when('paymentMethod', {
      is: PAYMENT_METHODS_VALUES.CHECK.toLowerCase(),
      then: Yup.string().required('This field is required'),
    }),
})

export const formOptions = { resolver: yupResolver(validationSchema) }

export default validationSchema
